// @ts-check
import React from 'react';
import classes from './DropdownMenu.module.scss';

const DropdownContent = ({ children }) => (
  <div className={classes.contentWrapper}>
    <div className={classes.content}>{children}</div>
  </div>
);

DropdownContent.displayName = 'DropdownContent';

export default DropdownContent;
